import React from 'react'

export const Loader = ({theme}) => {

    return (
        <div className={`content loading`}>
            <div className="wrapper loading">
                <div className="loader-wrapper">
                    <div className={`loader ${theme}`}>
                        <span></span>
                    </div>
                </div>
            </div>
        </div>
    )
}